import PropTypes from 'prop-types'

const IconPsychiatry = ({ style }) => {
  return (
    <svg viewBox="0 0 32 32" fill="none" style={style}>
      <mask id="mask_psychiatry" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32">
        <rect width="32" height="32" fill="#D9D9D9"/>
      </mask>
      <g mask="url(#mask_psychiatry)">
        <path d="M15.05 27.6167C14.7944 27.3611 14.6667 27.0444 14.6667 26.6667V17.3667C13.2444 17.3667 11.8778 17.0944 10.5667 16.55C9.25556 16.0056 8.1 15.2333 7.1 14.2333C6.1 13.2333 5.33333 12.0778 4.8 10.7667C4.26667 9.45556 4 8.08889 4 6.66667V5.33333C4 4.95556 4.12778 4.63889 4.38333 4.38333C4.63889 4.12778 4.95556 4 5.33333 4H6.66667C8.06667 4 9.42222 4.27222 10.7333 4.81667C12.0444 5.36111 13.2 6.13333 14.2 7.13333C14.8889 7.82222 15.4611 8.57778 15.9167 9.4C16.3722 10.2222 16.7222 11.1 16.9667 12.0333C17.0778 11.8778 17.2 11.7278 17.3333 11.5833C17.4667 11.4389 17.6111 11.2889 17.7667 11.1333C18.7667 10.1333 19.9222 9.36111 21.2333 8.81667C22.5444 8.27222 23.9111 8 25.3333 8H26.6667C27.0444 8 27.3611 8.12778 27.6167 8.38333C27.8722 8.63889 28 8.95556 28 9.33333V10.6667C28 12.0889 27.7278 13.4556 27.1833 14.7667C26.6389 16.0778 25.8667 17.2333 24.8667 18.2333C23.8667 19.2333 22.7167 20 21.4167 20.5333C20.1167 21.0667 18.7556 21.3333 17.3333 21.3333V26.6667C17.3333 27.0444 17.2056 27.3611 16.95 27.6167C16.6944 27.8722 16.3778 28 16 28C15.6222 28 15.3056 27.8722 15.05 27.6167Z" fill="white" fillOpacity="0.8"/>
      </g>
    </svg>
  )
}

IconPsychiatry.propTypes = {
  style: PropTypes.object,
}

export default IconPsychiatry
